// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const registerService = async (data) => {
  return api('/Sellitback.svc/Register', data, 'POST');
};

const registerSelectedAddressService = async (data) => {
  return api('https://api.craftyclicks.co.uk/address/1.1/retrieve', data, 'POST');
};

export {
  registerService,
  registerSelectedAddressService
};
